// extracted by mini-css-extract-plugin
export default {"container":"AddManufacturer_container__eOCVw","posts_box":"AddManufacturer_posts_box__9vcW9","progressContainer":"AddManufacturer_progressContainer__AFkMP"};